import { Box, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { useAppSelector } from "../../../store/hooks";
import CardView from "../../proprietaryWarranty/pages/proprietaryCardView";
import dayjs from "dayjs";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { jciFilterPagingAPI } from "../services/apiCall";
import { JobCardInvoicesKeys } from "../services/entity";
export var ReadyForInvoiceMobile = function (props) {
    var _getLocalStorageItem;
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    // const [activeView, setActiveView] = useState<string>("list");
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var listVariants = ["Job Card Invoice", 'Job Card Invoice'];
    var _a = useState(listVariants.length > 0 && isAllViewActive ? listVariants[0] : listVariants[1]), selectedListVariant = _a[0], setSelectedListVariant = _a[1];
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var getStockTransferList = useAppSelector(function (state) { return state.crud; }).getStockTransferList;
    var branch = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches.map(function (it) { return it === null || it === void 0 ? void 0 : it.OrganizationId; });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        isReadyForInvoiceTitle: true,
        isGrandTotalButton: true,
        isMenuIcon: false,
        isExpandButton: true,
        pagingApiCall: jciFilterPagingAPI,
        pagingKey: JobCardInvoicesKeys.JCIFilterPagingKey,
        pagingRequest: {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
            Branches: branch,
            Status: ["ReadyForInvoice"],
            PagingFor: "Job Card",
            take: 10,
            skip: 0
        },
        pageSize: 20,
        cardMapper: function (data) {
            var _data$Customer, _dayjs;
            return {
                id: "card-".concat(data.id),
                docNo: data.RegistrationNo,
                title: data === null || data === void 0 ? void 0 : data.ProductName,
                statusName: data === null || data === void 0 ? void 0 : data.StatusName,
                details: [{
                        label: "Job Card No :",
                        value: data === null || data === void 0 ? void 0 : data.JobCardNo
                    }, {
                        label: "Customer :",
                        value: data === null || data === void 0 || (_data$Customer = data.Customer) === null || _data$Customer === void 0 ? void 0 : _data$Customer.CustomerName
                    }, {
                        label: "Service Type :",
                        value: data === null || data === void 0 ? void 0 : data.ServiceTypeName
                    }, {
                        label: "Est deliver date and time:",
                        value: (_dayjs = dayjs(data === null || data === void 0 ? void 0 : data.DeliveryDate)) === null || _dayjs === void 0 ? void 0 : _dayjs.format('DD MMM, YYYY - hh:mm a')
                    }, {
                        label: "RFI date and time:",
                        value: data === null || data === void 0 ? void 0 : data.ServiceAdvisor
                    }]
            };
        },
        menuIcons: true
    })));
};
